import { ButtonProps, DialogContent, DialogProps as MuiDialogProps } from "@material-ui/core";
import { createStyles, makeStyles } from "@material-ui/core/styles";
import { ReactComponent as Cancel } from "assets/icons/cancel.svg";
import useText from "constants/text";
import React from "react";
import "styled-components/macro";
import Dialog from ".";

export const useStyles = makeStyles(() =>
  createStyles({
    dialogSpacingContent: {
      textAlign: "center",
      padding: "28px",
      fontSize: "1.2rem",
      fontWeight: "bold",
      color: "#a8a4a4",
    },
    cancel: {
      width: "230px",
      height: "141px",
      marginBottom: "15px",
    },
  })
);

export interface ExtendedButtonProps extends ButtonProps {
  "data-testid"?: string;
}

export interface DialogProps extends MuiDialogProps {
  title?: string;
  message?: string;
  onClose?(): void;
  onConfirm?(): void;
  open: boolean;
}

export default function CancellationDialog({ title, open, message, onConfirm, onClose, children }: DialogProps) {
  const { text } = useText();
  const classes = useStyles();
  const dialogRef = React.useRef(null);

  const handleClose = () => {
    onClose();
  };

  return (
    <>
      <Dialog
        title={title}
        open={open}
        confirmButtonTitle={text.all.yes_cancel}
        cancelButtonTitle={text.all.no_stay}
        handleConfirm={onConfirm}
        handleClose={handleClose}
        maxWidth="sm"
        fullWidth
      >
        <DialogContent ref={dialogRef} className={classes.dialogSpacingContent}>
          <Cancel className={classes.cancel} />
          {children}
          <div>{message}</div>
        </DialogContent>
      </Dialog>
    </>
  );
}
